<mat-card class="ui-card">
  @if (title()) {
    <mat-card-title class="ui-card__title">{{ title() }}</mat-card-title>
  }
  <mat-card-content>
    <ng-content />
  </mat-card-content>
</mat-card>
